import { en } from "./en";
import { pl } from "./pl";
import { de } from "./de";
import { es } from "./es";
import { fr } from "./fr";
import { sv } from "./sv";
import { nb } from "./nb";

export const resources = {
  en,
  pl,
  de,
  es,
  fr,
  sv,
  nb,
};
